import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "side-drawer-wrapper" }
const _hoisted_3 = { class: "side-drawer-header-text" }
const _hoisted_4 = { class: "side-drawer-title" }
const _hoisted_5 = {
  key: 0,
  class: "side-drawer-subtitle"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "side-drawer-body" }
const _hoisted_8 = {
  key: 0,
  class: "side-drawer-footer"
}
const _hoisted_9 = { class: "side-drawer-footer-actions" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.localVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, { name: "side-drawer" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "side-drawer-overlay" }, null, -1)),
              _createElementVNode("div", {
                class: "side-drawer-panel",
                style: _normalizeStyle({ width: _ctx.width })
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["side-drawer-header", { 'side-drawer-header--custom': _ctx.$slots.header }])
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "header", {}, () => [
                      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
                      (_ctx.subtitle !== '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.subtitle), 1))
                        : _createCommentVNode("", true)
                    ], true)
                  ]),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: "side-drawer-close",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Close && _ctx.Close(...args)))
                  }, [
                    _createElementVNode("img", { src: _ctx.crossIcon }, null, 8, _hoisted_6)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]),
                (_ctx.showFooter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _renderSlot(_ctx.$slots, "footer-left", {}, undefined, true),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-secondary btn-size-default",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.Cancel && _ctx.Cancel(...args)))
                        }, _toDisplayString(_ctx.localCancelText), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary btn-size-default",
                          disabled: _ctx.confirmDisabled,
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.Confirm && _ctx.Confirm(...args)))
                        }, _toDisplayString(_ctx.localConfirmText), 9, _hoisted_10)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 4)
            ])
          ]),
          _: 3
        })
      ]))
    : _createCommentVNode("", true)
}